// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import Element from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

import Dicts from './router/Dicts';
import Poster from './router/posterandspotlight';


Vue.config.productionTip = false

Vue.use(Element)
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.prototype.$dicts = Dicts;
Vue.prototype.$posters = Poster;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js